import styled from "styled-components";

export const VerticalBarBase = styled.div`
    box-sizing: border-box;
    width: 0;
    outline-offset: -1px;
    outline-width: 2px;
    outline-style: dashed;
    position: absolute;
    z-index: 49;
`;


// WEBPACK FOOTER //
// ./src/Components/VerticalBar/VerticalBarStyle.js